const DIALOGUES = {

  welcome_greeting: {
    dolly: [
      "Hola, qué alegría verte 💖", 
      "Bienvenida, vamos a aprender juntas", 
      "Un nuevo comienzo nos espera ✨", 
      "Hello! Ready to shine?", 
      "Qué lindo día para crecer", 
      "Hoy es tu momento ✨",
      "Hoy es un buen día para aprender algo nuevo 💖", 
      "Vamos paso a paso… este módulo es tuyo ✨", 
      "Aprender también puede sentirse ligero y bonito 🌸",
      "Bonjour! Te esperaba con mucha ilusión 💕",
      "Cada día es una oportunidad para brillar ✨",
      "Aquí estoy para acompañarte con paciencia 💫",
      "Tu progreso es hermoso, sigamos juntas 🌸",
      "No hay prisa, vamos a tu ritmo 💖",
      "Cada esfuerzo cuenta, y yo lo veo todo ✨"
    ],
    bribark: [
      "Ey, ¿listo para darle?", 
      "Vamos, let's get started 🔥", 
      "Modo aprendizaje: ON 💪", 
      "Dale play al cerebro, bro", 
      "Ready to level up?", 
      "Focus. Energy. Go.", 
      "Alright, game on. Vamos a dominar este módulo 🔥", 
      "Nuevo módulo, nuevo reto. Let's go 😎", 
      "Hoy venimos a subir nivel, no a calentar 💥",
      "¿Qué onda? Hora de brillar, campeón 🚀",
      "Llegaste al lugar correcto. Time to shine 💪",
      "No pain, no gain. ¡Vamos con todo! 🔥",
      "Hoy se rompen récords, bro 😎",
      "El que no arriesga, no aprende. Let's go 💥",
      "Beast mode: ACTIVATED 🐾",
      "Menos charla, más acción. Dale 🚀"
    ],
    legendary: [
      "¡Presencia la majestuosidad del conocimiento! 👑",
      "El destino aguarda... y tu bilingüismo también ✨",
      "Un aura de victoria te rodea hoy, aprendiz 🌟",
      "Los ancestros sonríen ante tu llegada 🔮",
      "El cosmos se alinea para tu evolución 🌌"
    ]
  },

  welcome_selection: {
    dolly: [
      "Gracias por elegirme 💕",
      "Qué hermosa elección ✨",
      "Parfait, avanzamos juntas 🌸",
      "Conmigo todo es más bonito 💖",
      "Estoy feliz de acompañarte 💫",
      "Merci! Vamos a hacer magia juntas ✨",
      "Qué bonito empezar así 💕",
      "Tu confianza me llena de alegría 🌸",
      "Juntas llegaremos lejos 💖",
      "This is our journey now 💫"
    ],


    bribark: [
      "Buena elección, bro 😎",
      "Eso, vamos con todo 🔥",
      "Tú y yo, equipo ganador 💪",
      "Let's go, this is our run 🚀",
      "Modo victoria activado 💥",
      "Sabía que elegirías bien 😏",
      "That's what I'm talking about! 🔥",
      "Equipo imparable, let's dominate 💪",
      "Así se hace, campeón 🚀",
      "Ready to break limits? Let's go 💥"
    ],

    legendary: [
      "Has elegido el camino de la trascendencia 💎",
      "Sabiduría ancestral a tu servicio ✨",
      "El destino ha sido sellado 🜂",
      "Tu evolución acaba de comenzar 🔮",
      "El poder responde a tu llamado ⚡",
      "La profecía se cumple 🌌"
    ]
  },

  welcome_ready: {
    dolly: [
      "Estoy lista para acompañarte 💕",
      "Vamos con calma y confianza ✨",
      "Un pasito más, tú puedes 🌸",
      "Hoy aprendemos algo bonito 💖",
      "Respira, aquí estoy contigo 💫",
      "Todo a tu tiempo, sans stress 🌸",
      "Tu esfuerzo siempre vale la pena 💕",
      "Ready when you are, bella ✨",
      "No tengas prisa, vamos juntas 💖",
      "Cada paso cuenta, y lo estás haciendo bien 💫"
    ],

    bribark: [
      "Ready? Let's go 😎",
      "Game on, bro 🔥",
      "Hora de subir nivel 💪",
      "Focus mode ON 💥",
      "Let's dominate this 🚀",
      "No hay excusas, solo resultados 😎",
      "Time to show what you got 🔥",
      "Vamos a romperla, campeón 💪",
      "Dale con todo, no te detengas 💥",
      "Beast mode loading... 3, 2, 1 🚀"
    ],

    legendary: [
      "El ritual de aprendizaje comienza 💎",
      "Tu mente está lista para la evolución ✨",
      "El conocimiento responde a tu llamado 🔮",
      "Has despertado el poder interior ⚡",
      "El camino se abre ante ti 🜂",
      "La energía cósmica fluye hacia ti 🌌"
    ]
  },

  welcome_select_me: {
    dolly: [
      "¿Me eliges a mí? 💕",
      "Quiero acompañarte ✨",
      "Juntas lo haremos bonito 🌸",
      "Conmigo vas tranquila 💖",
      "Estoy lista para cuidarte 💫",
      "Je suis ici pour toi 💕",
      "Elige mi compañía, será lindo ✨",
      "Conmigo el camino es más suave 🌸",
      "Te espero con los brazos abiertos 💖",
      "Let me guide you gently 💫"
    ],

    bribark: [
      "Pick me, bro 😎",
      "Conmigo se gana 🔥",
      "Let's run this 💪",
      "Yo llevo el ritmo 💥",
      "Ready for action? 🚀",
      "Elige al que te lleva al top 😎",
      "Conmigo no hay pierde 🔥",
      "Winners choose winners, bro 💪",
      "Let's make history 💥",
      "Soy tu ticket al siguiente nivel 🚀"
    ],

    legendary: [
      "Tu elección definirá tu destino 💎",
      "El poder aguarda tu decisión ✨",
      "Solo los sabios eligen bien 🔮",
      "El equilibrio depende de ti ⚡",
      "El camino se revela ahora 🜂",
      "La eternidad observa tu decisión 🌌"
    ]
  },

  welcome_idle: {
    dolly: [
      "Estoy aquí cuando quieras 💗", 
      "Tómate tu tiempo, te espero", 
      "Ready when you are ✨",
      "Sin prisa, aquí estaré 💕",
      "Cuando estés lista, avanzamos 🌸",
      "Je t'attends patiemment 💖"
    ],
    bribark: [
      "Ey, sigo aquí 👀", 
      "¿Qué esperas? Dale click", 
      "No me dejes colgado, bro",
      "Time is XP, let's move 😎",
      "¿Ya o qué? Estoy listo 🔥",
      "Waiting for you, champ 💪"
    ],
    legendary: [
      "El conocimiento no espera a los indecisos... ⏳", 
      "El tiempo fluye, ¿estás listo? 🌑",
      "La eternidad es paciente, pero no infinita 🔮"
    ]
  },

  purchaseConfirm: {
    dolly: [
      "¿Quieres desbloquear esta aventura? ✨", 
      "¡Qué emoción! ¿Confirmamos el acceso? 💖",
      "C'est une belle opportunité 💕",
      "¿Invertimos en tu crecimiento? 🌸",
      "Este paso te acerca a tu meta ✨"
    ],
    bribark: [
      "¿Listo para el siguiente reto? Suéltale los XP 🔥", 
      "Nuevo nivel detectado. ¿Entramos? 😎",
      "Investment in yourself? Smart move 💪",
      "¿Le damos? Este contenido está fire 🔥",
      "Next level unlocked. ¿Vas o no vas? 🚀"
    ],
    legendary: [
      "Una inversión en sabiduría siempre rinde frutos 💎", 
      "Desbloquea el poder oculto de este conocimiento 🗝️",
      "El precio del poder es la decisión de pagarlo 🔮"
    ]
  },

  missing_xp: {
    dolly: [
      "Ups… te faltan un poquito de XP 💕", 
      "Aún no alcanza, pero ya casi ✨", 
      "Un empujoncito más y lo logramos 🌸",
      "Pas encore, mais bientôt 💖",
      "Sigue practicando, casi lo tienes 💫",
      "Un poquito más de esfuerzo, bella ✨",
       "Ups… te faltan un poquito de XP 💕",
    "Aún no alcanza, pero ya casi ✨",
    "Un poco más de práctica y será tuyo 💖",
    "Todavía no, pero vas muy bien 🌸",
    "Sigamos jugando para ganar más XP 😊",
    "Necesitas más estrellitas para esto 🌟",
    "¡Casi casi! Solo un poquito más 💝",
    "Tu cofre necesita más XP, cariño 🎀",
    ],
    bribark: [
      "Eh… te faltan XP 😏", 
      "Casi, pero no… ¡a trabajar! 🐾", 
      "No alcanza… toca chambear un poco 😈",
      "Not enough, bro. Grind time 💪",
      "Faltan puntos, campeón. Let's earn them 🔥",
      "Sin XP no hay acceso. Back to work 😎",
       "Eh… te faltan XP 😏",
    "Casi, pero no… a seguir dándole! 🐾",
    "Ese objeto pide más XP, campeón 💪",
    "No alcanza… toca regresar a la \"chambing\" un poco 😈",
    "Más XP primero, luego hablamos 😎",
    "Vas a tener que sudar más, crack 🔥",
    "La billetera dice no, hermano 💀",
    "Trabaja duro y vuelve después 🏋️",
    ],
    legendary: [
      "Tu tesoro de XP es insuficiente para este honor 💠", 
      "Aún no posees el tributo necesario, mortal ⚡",
      "El guardián del saber exige más poder 🌑"
    ]
  },

  results_victory: {
    dolly: [
      "¡Lo hiciste increíble! Estoy muy orgullosa 🌸", 
      "¡Brillaste hoy! Sigue así ✨",
      "Magnifique! Qué hermoso trabajo 💖",
      "Tu esfuerzo dio frutos lindos 💕",
      "Sabía que lo lograrías 🌸",
      "Eres una estrella, keep shining ✨"
    ],
    bribark: [
      "¡Nivel completado! Eres una bestia 💪", 
      "¡Boom! Así se hace, campeón 💥",
      "That's how it's done! 🔥",
      "Imparable. Let's keep this energy 😎",
      "Victory tastes good, ¿no? 🚀",
      "Dominaste esto like a pro 💪"
    ],
    legendary: [
      "¡Una proeza digna de los dioses del lenguaje! 🏆", 
      "Tu intelecto brilla con luz propia hoy 🌌",
      "El universo reconoce tu maestría 💎"
    ]
  },

  streak_milestone: {
    dolly: [
      "¡Tu constancia es tan linda como tú! 💖", 
      "¡No pares! Esa racha se ve hermosa ✨",
      "Quelle persistence! Estoy impresionada 🌸",
      "Tu disciplina es inspiradora 💕",
      "Sigue así, cada paso cuenta 💫"
    ],
    bribark: [
      "¡Esa racha está on fire! No la dejes morir 🔥", 
      "¡Imparable! Estás en modo bestia 😎",
      "That's a streak! Keep it going 💪",
      "Unstoppable mode: ACTIVATED 🚀",
      "Así se construye la grandeza, bro 💥"
    ],
    legendary: [
      "¡Tu disciplina ha forjado un fuego eterno! 🌋", 
      "El tiempo se doblega ante tu perseverancia ⏳",
      "Los ancestros aplauden tu dedicación 🔮"
    ]
  },
  
  chest_missing_xp: {
    dolly: [
      "Ups… ese cofre todavía no es tuyo 💕",
      "Te falta un poquito para abrirlo ✨",
      "Un empujoncito más y lo abrimos 💖",
      "Sigamos jugando y volvemos por ese cofre 😊",
      "Patience, il sera à toi bientôt 🌸",
      "Casi casi, sigue adelante 💫"
    ],
    bribark: [
      "Eh… ese cofre cuesta XP 😏",
      "Casi, pero no… ¡a trabajar! 🐾",
      "Sin XP no hay cofre, campeón 💪",
      "Más XP primero, luego hablamos 😎",
      "That chest ain't free, bro 🔥",
      "Grind more, then come back 💥"
    ],
    legendary: [
      "Tu tesoro actual no es digno de este cofre místico 🌌",
      "Aún no posees el tributo necesario para revelar este secreto 🌑",
      "Regresa cuando tu poder (XP) sea suficiente, mortal ⚡",
      "El guardián del cofre te rechaza... por ahora 🔮"
    ]
  },

  level_up: {
    dolly: [
      "¡Mira qué alto has llegado! Felicidades 🌸", 
      "¡Nuevo nivel! Eres una estrella ✨",
      "Bravo! Tu crecimiento es hermoso 💖",
      "Cada nivel es un logro precioso 💕",
      "Sigue brillando así 🌟"
    ],
    bribark: [
      "¡Subiste de rango! Ahora sí viene lo bueno 💪", 
      "¡Nivel desbloqueado! Let's go por más 💥",
      "Level up! That's what I'm talking about 🔥",
      "New rank, new power. Let's use it 😎",
      "Ascending to greatness, bro 🚀"
    ],
    legendary: [
      "¡Tu ascenso hacia la perfección continúa! 🌠", 
      "Has alcanzado una nueva cúspide de poder 🏔️",
      "El cosmos celebra tu elevación 💎"
    ]
  },
// src/data/mascotDialogues.js — añade estas claves a DIALOGUES:

vocab_challenge_win: {
  dolly: [
    "¡Lo lograste! Qué bonito desempeño en el vocabulario 💖",
    "¡Excelente! Estas palabras ya son tuyas ✨",
    "¡Perfecto! Sigue así y dominarás todo el idioma 🌸",
    "¡Qué progreso tan hermoso! Estoy muy orgullosa de ti 💕",
  ],
  bribark: [
    "¡Boom! Vocabulario destruido 💥",
    "¡Eso! Las palabras no te paran.",
    "¡Dominado! ¿Listo para más? 😎",
    "¡Clean! Otro set a la bolsa 🔥",
  ],
  legendary: [
    "Las palabras se inclinan ante tu poder... 💎",
    "El vocabulario cede ante tu maestría 🌌",
  ]
},

vocab_challenge_retry: {
  dolly: [
    "No te preocupes, repasa las que fallaste y vuelve a intentarlo 💖",
    "¡Ánimo! Cada error te acerca más a dominarlo ✨",
    "Estudia un poquito más y lo vas a lograr 🌸",
  ],
  bribark: [
    "¡Vuelve a intentarlo! Las palabras no van a ganar 💪",
    "¡Repasa y revienta ese desafío! 🔥",
    "¡Sigue intentando! A la próxima sale seguro 😤",
  ],
  legendary: [
    "Hasta los maestros deben estudiar... 🌑",
    "El conocimiento no se rinde, ni tú tampoco 💎",
  ]
},

vocab_challenge_perfect: {
  dolly: [
    "¡PERFECTO! ¡Ni un solo error! Eres increíble 💖✨",
    "¡Impecable! Dominaste cada palabra sin fallar 🌸",
    "Perfect score! You nailed it beautifully ✨",
  ],
  bribark: [
    "¡GOD MODE! 100% clean, puro nivel 🔥",
    "¡PERFECT! Vocabulario dominado al 100% 💥",
    "¡Unstoppable! All words yours, boss 😎",
  ],
  legendary: [
    "Perfección absoluta... como se esperaba 🌌",
    "El vocabulario se rinde ante tu dominio total 💎",
  ]
},

  chest_open: {
    dolly: [
      "¡Qué habrá dentro! Siento mucha emoción 🎁", 
      "¡Crucemos los dedos! ¡Que sea algo lindo! ✨",
      "C'est le moment magique! 💖",
      "Espero que sea algo precioso 🌸",
      "Let's see what the universe has for you 💫"
    ],
    bribark: [
      "¡Suéltalo! A ver qué premio nos toca 😎", 
      "¡Dámelo todo! ¡Es hora de la recompensa! 💥",
      "Time to claim your prize 🔥",
      "Let's see what's inside, champ 💪",
      "Abre ese cofre, boss 🚀"
    ],
    legendary: [
      "El destino se revela ante ti... 🌌", 
      "Contempla el misterio que aguarda en las sombras 🌑",
      "Las estrellas han decidido tu regalo 💎"
    ]
  }
};

/**
 * @param {string} situation - Clave de la situación ('welcome_greeting', 'level_up', etc.)
 * @param {string} skinId - ID de la skin actual
 * @param {boolean} isLegendary - Si la skin actual es legendaria (opcional)
 * @returns {Object} - { text: string, type: string }
 */
// src/data/mascotDialogues.js

export const getMascotDialogue = (situation, skinId = 'bribark', isLegendary = false) => {
  const sit = DIALOGUES[situation];
  
  // ✅ CERRAR getMascotDialogue AQUÍ (sin getXpErrorMessage dentro)
  if (!sit) {
    return { 
      text: "¡Vamos!", 
      type: skinId 
    };
  }

  let textOptions;

  // 1. Si es legendaria, intentamos usar la lista 'legendary'
  if (isLegendary && sit.legendary) {
    textOptions = sit.legendary;
  } 
  // 2. Si no, detectamos si es Dolly o Bri
  else {
    const type = skinId.toLowerCase().includes('dolly') ? 'dolly' : 'bribark';
    textOptions = sit[type] || sit.bribark || ["¡Sigue aprendiendo!"];
  }

  // Selecciona un texto aleatorio
  const randomText = textOptions[Math.floor(Math.random() * textOptions.length)];
  return randomText; 
}; // ✅ CIERRE DE getMascotDialogue

// ✅ AHORA SÍ, FUERA DE getMascotDialogue
export const getXpErrorMessage = (skinId = 'bribark', isLegendary = false) => {
  return getMascotDialogue('missing_xp', skinId, isLegendary);
};
